import React from "react";
import { useParams } from "react-router-dom";
import CreateForm from "../components/CreateForm";

// Adding  Item
function AddItems() {
  const { itemId } = useParams();

  return (
    <>
      <CreateForm levelNumber={1} itemId={itemId} />
    </>
  );
}

export default AddItems;
